<template>
  <v-card color="white" flat class="pa-1 position-relative py-3">
    <Block v-if="isLoading"></Block>
    <!-- Search panel -->
    <v-row class="py-3">
      <v-col class="d-flex justify-space-between ml-3 mr-3">
        <div class="text-h4">Lotes</div>
        <div class="d-flex">
          <v-text-field 
            v-model="searchText"
            prepend-icon="mdi-magnify"
            placeholder="Buscar..." 
            class="mr-1 f-flex align-center"
            style="width: 100%; width: 350px;"
            hide-details
            outlined
            dense
            @keydown.enter.prevent="search"
          />
          <Button prepend-icon="mdi-magnify" @click="search()">
            Buscar
          </Button>
        </div>
      </v-col>
    </v-row>
    <!-- Lots table -->
    <CustomerLots 
      :lots="lots" 
      :services="services"
      :customers="customers"
      :sellers="sellers"
      :sale-types="saleTypes"
      :reservation-types="reservationTypes"
      @row-selected="(row) => selectedLot = row"
    />

    <v-dialog 
      v-model="showLotInstallments" 
      @close="selectedLot = null"
      @click:outside="selectedLot = null"
      max-width="1000px"
      max-height="90vh"
      scrollable
    >
      <LotInstallments 
        v-if="selectedLot" 
        :lot-data="selectedLot"
        @lot-updated="reload"
        @lot-deleted="reload"
        @lot-refinanced="reload"
        @row-selected="data => {
          selectedInstallment = data.row
          saleData = data.saleData
          planData = data.planData
        }"
        @close="selectedLot = null"
      />
    </v-dialog>

    <v-dialog 
      v-model="showInstallmentForm" 
      @close="selectedInstallment = null"
      @click:outside="selectedInstallment = null"
      max-width="1000px"
      max-height="90vh"
      scrollable
    >
      <InstallmentForm 
        v-if="selectedInstallment" 
        :lot-data="selectedLot"
        :installment-data="selectedInstallment"
        :sale-data="saleData"
        :plan-data="planData"
        @installment-updated="() => {
          selectedInstallment = null;
          saleData = null;
          planData = null;
          reload();
        }"
        @row-selected="selectedInstallment = null"
        @close="
          selectedInstallment = null;
          saleData = null;
          planData = null;
        "
      />
    </v-dialog>


    <Alert
      v-model="alert.show"
      :type="alert.type"
      :title="alert.title"
      :message="alert.message"
      @input="alert.onInputEvent"
      @action="alert.onActionEvent"
    />
  </v-card>
</template>

<script>
import {mapState} from 'vuex';
import CustomerLots from './CustomerLots.vue';
import Block from '@/components/Block.vue';
import Alert from '@/components/Alert.vue';
import Button from '@/components/Button.vue'
import LotInstallments from './LotInstallments.vue';
import InstallmentForm from './InstallmentForm.vue';

export default {
  name: 'CustomerFinancing',
  components: {
    CustomerLots,
    Block,
    Alert,
    Button,
    LotInstallments,
    InstallmentForm
  },
  props:['customer', 'win'],
  data() {
    return {
      isLoading: false,
      panel: 0,
      tab: null,
      lots: [],
      saleData: null,
      planData: null,
      alert: {
        type: 'success',
        show: false,
        header: '',
        body: '',
        onInputEvent: this.closeAlert,
        onActionEvent: this.closeAlert,
      },
      services: [],
      customers: [],
      sellers: [],
      saleTypes: [],
      reservationTypes: [],
      selectedLot: null,
      selectedInstallment: null,
      searchText: '',
    }
  },
  computed: {
    ...mapState(
      'rolesUser',
      {
        rolesStatus: (state) => state.roles,
      }
    ),
    showLotInstallments() {
      return !!this.selectedLot
    },
    showInstallmentForm() {
      return !!this.selectedInstallment
    },
  },
  methods: {
    async loadLots() {
      try {
        const ID_Business = JSON.parse(localStorage.getItem("user")).businessid
        const ID_Branch = JSON.parse(localStorage.getItem("user")).branch

        const search = {
          ID_Business,
          ID_Branch,
          ID_Customer: this.customer?.ID_Customer
        };

         const searchText = this.searchText.trim();

        if (searchText) {
          search.text = searchText; 
        }

        const response = await this.$API.realstate.getCustomerLots({
          search
        });

        this.lots = response.data
      } catch(err) {
        this.showAlert('Error', 'Ha ocurrido obteniendo la lista de lotes.', 'error');
      }
    },
    async loadServices() {
      try {
        const response = await this.$API.services.getAllServices({ noLimit: true });

        this.services = response;
      } catch(err) {
        this.showAlert('Error', 'Ha ocurrido obteniendo la lista de servicios.', 'error');
      }

      this.isLoading = false;
    },
    async loadCustomers() {
      try {
        const business = JSON.parse(localStorage.getItem("user")).businessid || ""
        const branch = JSON.parse(localStorage.getItem("user")).branch || ""

        const response = await this.$API.customers.getCustomers({
          business,
          branch
        })

        this.customers = response;
      } catch(err) {
        this.showAlert('Error', 'Ha ocurrido obteniendo la lista de clientes.', 'error');
      }
    },
    async loadSellers() {
      try {
        const response = await this.$API.sellers.getAllSellersFiltered();

        this.sellers = response;
      } catch(err) {
        this.showAlert('Error', 'Ha ocurrido obteniendo la lista de vendedores.', 'error');
      }
    },
    async loadSaleTypes() {
      try {
        const response = await this.$API.realstate.getSaleTypes();

        this.saleTypes = response;
      } catch(err) {
        this.showAlert('Error', 'Ha ocurrido obteniendo la lista de tipos de venta.', 'error');
      }
    },
    async loadReservationTypes() {
      this.isLoading = true;
      try {
        const response = await this.$API.realstate.getReservationTypes();

        this.reservationTypes = response;

      } catch(err) {
        this.showAlert('Error', 'Ha ocurrido obteniendo la lista de tipos de reserva.', 'error');
      }
    },
    showAlert(title, message, type = 'success', onInputEvent, onActionEvent) {
      this.alert.type = type;
      this.alert.title = title;
      this.alert.message = message;
      this.alert.show = true;
      this.alert.onInputEvent = onInputEvent 
        ? onInputEvent
        : this.closeAlert;
      this.alert.onActionEvent = onActionEvent 
        ? onActionEvent
        : this.closeAlert;
      
    },
    closeAlert() {
      this.alert.show = false;
    },
    async reload() {
      this.$store.dispatch('rolesUser/getAllRoles')
      this.isLoading = true
      try {
        await Promise.all([
          this.loadLots(),
          this.loadSaleTypes(),
          this.loadReservationTypes(),
          this.loadServices(),
          this.loadCustomers(),
          this.loadSellers(),
        ]);
      
      if (this.selectedLot) {
        this.selectedLot = {...this.selectedLot }
      }
      } catch (err) {
        console.log(err)
      }

      this.isLoading = false
    },
    search() {
      this.loadLots()
    }
  },
  mounted(){
    this.reload()
  }
}
</script>